import {initialYearClassroom} from '../../utils/classroomYear'
/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage} from '../modules/auth'
import {App} from '../App'
import { useDispatch, useSelector } from "react-redux";
import { IClassroom, reduxProps } from "../../constants";
import { useEffect } from "react";
import {
  actionGetStaffClassrooms, actionGetStudents,
  actionSaveSelectedClass
} from "../../redux/education";
import { actionGetSubUserAvatars } from "../../redux/user";
import { actionGetAvatars } from "../../redux/content";
import Register from "../../education/register";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

export function AppRoutes () {
  const {staffInfo} = useSelector((state:reduxProps) => state.authReducer)
  const {classrooms,classroom} = useSelector((state:reduxProps) => state.educationReducer)
  const dispatch = useDispatch()
  useEffect(() => {
    if (staffInfo.id > 0 && staffInfo.classroomIds.length>0) {
      dispatch(
        actionGetStaffClassrooms({userId:staffInfo.id},
          (r) => {
            if (r.type === 'SUCCESS') {
              if (r.payload.data.length > 0 && classroom.id ===0 ) {
                let selectedClassroom : IClassroom = initialYearClassroom(r.payload.data)
                dispatch(actionSaveSelectedClass(selectedClassroom))
                if (!selectedClassroom.id) return
                dispatch(actionGetStudents({classroomId:selectedClassroom.id},(r)=>{
                  if (r.type === "SUCCESS"){
                    let userIds = r.payload.data.map((item:any)=>item.subUserId);
                    dispatch(actionGetSubUserAvatars({ids:JSON.stringify(userIds)}))
                    dispatch(actionGetAvatars({}))
                  }
                }))
              }
            }
          }
        )
      )
    }
  }, []);
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='auth/*' element={<AuthPage />} />
          {staffInfo && staffInfo.id>0  ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='*' element={<Navigate to='/auth' />} />
              <Route path='/register' element={<Register/>} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
